/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { IAgentPlugin, IPluginMethodMap } from '@vlinder-web/plugin-agent-service-react';
import config from '../config/committeList.config.json';
import member from '../config/memberDetail.config.json';
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { VApplication } from '../../../application';
import moment from 'moment-timezone';
import { GET_COMMITTE_LIST, GET_PRESENTATIONS } from '../graphql';
import { pretty } from '@vlinder-web/utils-react';

const is = require('is_js');
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

export interface ISingleCommitteMethods extends IPluginMethodMap {
  getSingleCommitteProps(args: any): Promise<any>;
}

export class SingleCommitteService implements IAgentPlugin {
  readonly methods: ISingleCommitteMethods;

  constructor() {
    this.methods = {
      getSingleCommitteProps: this.getSingleCommitteProps.bind(this),
    };
  }

  async getSingleCommitteProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient('graphql-gateway');
    let filter: any = args.id
      ? {
        Invites___user: {
          eq: args.id,
        },
      }
      : {};
    const _filter = {
      status: {
        eq: "active",
      },
      // year: {
      //   eq: "2024",
      // },
    };
    const presentation = await client.query({
      query: GET_PRESENTATIONS,
      variables: {
        filter: _filter,
        options: {
          limit: 10,
          skip: 0,
          sort: {
            field: "status",
            order: "asc",
          },
        },
      },
      fetchPolicy: "network-only",
    });
    let defaultPresentation: any = "";

    if (presentation?.data) {
      console.log(presentation?.data)
      defaultPresentation =
        presentation?.data?.getPresentations?.content[0]?.id;
    }
    filter = {
      ...filter,
      Invites___presentation: {
        eq: args?.presentation ? args?.presentation : defaultPresentation
      }
    }
    try {
      if (client) {
        const res = await client.query({
          query: GET_COMMITTE_LIST,
          variables: {
            filter: filter,
          },
          fetchPolicy: 'network-only',
        });
        if (res?.data) {
          let result = res?.data?.getAllCommitteInviteStatus?.content;
          // console.log("res_data==>", pretty(result));
          const rows = this.formatUserTable(result);
          let _totalPages = result?.count ? Math.ceil(parseInt(result?.count) / 10) : 1;

          let _currentPage = res?.data?.getPresentations?.skip / res?.data?.getPresentations?.limit + 1;
          return {
            ...config,
            ...member,
            ultUsers: rows,
            isEmpty: rows.length <= 0,
            activePage: _currentPage,
            pageSize: res?.data?.getPresentations?.limit,
            totalCount: rows.length,
            totalPages: _totalPages,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
    return { ...(config || {}) };
  }

  private formatUserTable(result: any) {
    let rows: any[] = [];
    result.forEach((item?: any) => {
      console.log(item);
      let user = {
        id: item?.id ?? '-',
        firstName: item?.firstName ?? '',
        surname: item?.lastName ?? '',
        fullName: item?.firstName
          ? item?.lastName
            ? item?.firstName + ' ' + item?.lastName
            : item?.lastName
          : item?.lastName
            ? item?.lastName
            : item?.email,
        email: item?.email ?? '',
      }
      let maxInvites = 0,
        purchased = 0,
        inviteUsed = 0;
      let collection: any[] = [];
      item?.Invites.forEach((invite?: any) => {
        maxInvites += invite?.maxInvites ?? 0;
        inviteUsed += invite?.referalsUsed ?? 0;
        purchased += invite?.purchased ?? 0;
        let remaining = (invite?.maxInvites ?? 0) - (invite?.referalsUsed ?? 0);
        collection.push({
          _id: invite?.id ?? '-',
          maxInvites: invite?.maxInvites ?? 0,
          inviteUsed: invite?.referalsUsed ?? 0,
          partition: invite?.partition ?? 0,
          sectionOptType: invite?.sectionOptType ?? '-',
          sectionName: invite?.sections?.name ?? '-',
          purchased: invite?.purchased ?? 0,
          remaining: remaining > 0 ? remaining : 0,
          inviteType: invite?.inviteType ?? '-',
        });
      });
      rows.push({
        ...user,
        collection: collection
      })
    })
    return rows;
  }
}
